import { api } from "@/lib/api";

function urlB64ToUint8Array(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const base = (b64 + pad).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function currentSubscription() {
  if (!(await isPushSupported())) return null;
  const reg = await navigator.serviceWorker.getRegistration("/eco-sw.js");
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/eco-sw.js");
  } catch (e) {
    return null;
  }
}

export async function subscribeToPush() {
  if (!(await isPushSupported())) throw new Error("Push not supported in this browser");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission not granted");
  const reg = (await ensureServiceWorker()) || (await navigator.serviceWorker.ready);
  const { data } = await api.get("/push/public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.key),
  });
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await currentSubscription();
  if (!sub) return;
  const json = sub.toJSON();
  await api.post("/push/unsubscribe", { endpoint: json.endpoint, keys: json.keys });
  await sub.unsubscribe();
}
